export default {
  "1": "tier 1".toUpperCase(),
  "2": "tier 2".toUpperCase(),
  "3": "tier 3".toUpperCase(),
  low: "low content".toUpperCase(),
}
